import script from "./biz-form-times.vue?vue&type=script&lang=ts&setup=true"
export * from "./biz-form-times.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__